import { Divider } from '@mui/material';
import React, { Fragment, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormControls,
  FormikArray,
  FormikMultiSelect,
  FormikSelect,
} from 'components';
import { useUserContext } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { formUtils } from 'utils';

export const CustomerBanksConfig: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.sci_domains',
  });
  const { banks } = useUserContext();

  const bankOptions = useMemo(
    () => formUtils.getOptions(banks, 'name', 'code'),
    [banks],
  );

  const renderItemComponent = useCallback(
    ({ index }: { index: number }) => (
      <FormControls sx={{ flex: 1 }}>
        <FormikSelect
          label={t('fields.requisites_bank')}
          name={`customerBankConfigs[${index}].bank`}
          noneOption={false}
          options={bankOptions}
        />
        <FormikMultiSelect
          label={t('fields.customer_banks')}
          name={`customerBankConfigs[${index}].customerBanks`}
          options={bankOptions}
        />
      </FormControls>
    ),
    [t, bankOptions],
  );

  return (
    <Fragment>
      <Divider>{t('fields.customer_bank_config')}</Divider>
      <FormikArray
        addItemLabel={t('details_dialog.add_customer_bank_config')}
        name="customerBankConfigs"
        removable
        defaultValue={{ bank: '', customerBanks: [] }}
        ItemComponent={renderItemComponent}
      />
    </Fragment>
  );
};
